export const Divider = () => (
  <div className="h-px w-full bg-[#d9d9d9]" />
);
